module.exports = __webpack_public_path__ + "img/Patch20.c62d5cf2.webp";